import React, { PropTypes } from 'react';

import { apiErrorPropType, eventFullPropType } from '../../proptypes';

import Container from '../Container';
import EventDetailPageMeta from './components/EventDetailPageMeta';
import EventDetail from '../EventDetail';
import LoadingEllipsis from '../LoadingEllipsis';
import { getObjFromHashParamString } from '../../utils/urls';

import { container } from './styles.module.css';

/**
 * Event detail page presentational component.
 * Combines event detail component with loading and/or error components.
 */
const EventDetailPage = ({ fetching, error, event, onShare, router, searchQuery, similarQuery }) => {

  if (event) {
    const { location = {} } = router;
    return (
      <div>
        <EventDetailPageMeta {...event} />
        <EventDetail
          {...event}
          onShare={onShare}
          searchQuery={searchQuery}
          similarQuery={similarQuery}
          source={getObjFromHashParamString(location.hash).source}
        />
      </div>
    );
  }
  if (fetching) {
    return (
      <Container className={container}>
        <LoadingEllipsis htmlTag="h1" />
      </Container>
    );
  }
  return (
    <Container className={container}>
      <h1>{error && error.status === 404 ? 'Event not found' : 'Something went wrong'}</h1>
    </Container>
  );
};

EventDetailPage.propTypes = {
  /**
   * Boolean describing current loading state.
   */
  fetching: PropTypes.bool,
  /**
   * Object representing current error state.
   */
  error: apiErrorPropType,
  /**
   * Event data object.
   */
  event: eventFullPropType,
  /**
   * Tracking function called when user clicks on 'Share' button.
   */
  onShare: PropTypes.func,
  /**
   * Router object.
   */
  router: PropTypes.shape(),
  /**
   * Query object for 'search' query.
   */
  searchQuery: PropTypes.shape(),
  /**
   * Query object for 'similar' query.
   */
  similarQuery: PropTypes.shape(),
};

EventDetailPage.defaultProps = {
  fetching: false,
  error: null,
  event: null,
  onShare: () => {},
  searchQuery: undefined,
  similarQuery: undefined,
  router: {},
};

export default EventDetailPage;



// WEBPACK FOOTER //
// ./app/src/components/EventDetailPage/index.jsx